import { InjectionToken } from '@angular/core';
import { Occ } from '../../../../core/occ';
import { Converter } from '../../../../core/util/converter.service';

export const COLLECTION_VALUE_NORMALIZER = new InjectionToken<Converter<Occ.CollectionValue<string>, Array<string>>>(
  'CollectionValueNormalizer'
);
